<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">发布名称：</span>
        </div>
        <el-input v-model="formData.publishName" size="small" style="width: 280px" />
      </div>
      <!-- <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">项目名称：</span>
        </div>
        <el-select v-model="formData.projectCode"
                   filterable
                   remote
                   disabled
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请选择项目名称">
          <el-option v-for="item in projectList" :key="item.code"
                     :label="item.projectName" :value="item.code">
          </el-option>
        </el-select>      
      </div>      -->
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">截止时间：</span>
        </div>
        <el-date-picker v-model="formData.deadlineDate" value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="截止时间" size="small" style="width: 280px"></el-date-picker>
      </div>                       
    </form>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>    
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { bus } from "../../../utils/bus";
import { api } from "../../api/Questionnaire";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "questionnaire-publishment-modify",
  data() {
    return {
      breadcrumb: [
        {
          value: "数据采集",
          name: "questionnaire-template-manage"
        },
        {
          value: "项目发布"
        }
      ],
      mainTitle: "修改发布",
      subheading: "",
      formData: {
        publishName: "",
        deadlineDate: "",
        projectCode: "",
        projectName: ""
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      projectCodes: "",
      projectList: []
    };
  },
  created() {
    this.remoteMethod();
    this.getPublishmentByCode();
  },
  methods: {
    getPublishmentByCode() {
      this.$axios
        .get(`${api.getPublishmentByCode}/${this.$route.params.id}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            console.log(res);
            this.formData = res.data.data;
          }
        })
        .catch(errorHandler("查询失败"));
    },
    remoteMethod(query) {
      this.getProjectList(query);
    },
    getProjectList(searchKey) {
      this.$axios
        .post(api.getProjectList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            this.projectList = list;
          }
        })
        .catch(errorHandler("获取模板列表失败"));
    },
    confirm() {
      if (!this.formData.publishName) {
        nError("请输入发布名称");
        return false;
      }
      if (!this.formData.deadlineDate) {
        nError("请选择截止日期");
        return false;
      }
      this.$axios
        .post(api.updatePublishment, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.$router.push({
              name: "questionnaire-publishment-manage"
            });
          }
        })
        .catch(errorHandler("修改失败"));
    },
    cancel() {
      this.$router.push({
        name: "questionnaire-publishment-manage"
      });
    }
  },
  watch: {
    projectCodes(val) {
      this.projectList.map(v => {
        if (v.code === val) {
          this.formData.projectCode = v.code;
          this.formData.projectName = v.projectName;
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/Questionnaire/QuestionnairePublish/QuestionnairePublishmentModify.vue